import { render, staticRenderFns } from "./Q2Edit.vue?vue&type=template&id=baa938e8&scoped=true&"
import script from "./Q2Edit.vue?vue&type=script&lang=js&"
export * from "./Q2Edit.vue?vue&type=script&lang=js&"
import style0 from "./Q2Edit.vue?vue&type=style&index=0&id=baa938e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa938e8",
  null
  
)

export default component.exports